(function() {
    const utm = '&utm_campaign=referral-program(banner)';
    
    const checkAndAppend = setInterval(function() {
        const input = document.getElementById('sca_customer_refer_email');
        
        if (input && input.value && !input.value.includes(utm)) {
            input.value = input.value + utm;
            clearInterval(checkAndAppend);
        }
    }, 100);
    
    setTimeout(() => clearInterval(checkAndAppend), 10000);
})();